import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-collapsible',
    imports: [NgIf],
    templateUrl: './collapsible.component.html',
    styleUrls: ['./collapsible.component.css'] // fixed styleUrl
})
export class CollapsibleComponent {
  @Input() title: string = '';
  @Input() contentLeftMargin: string = '16px'; // configurable margin
  @Input() titleFontSize: string = '1rem';
  @Input() titleBackgroundColor: string = '#f3f3f3';
  @Input() open = false;
  @Input() titleFontWeight: string = 'normal';
 
  toggle() { this.open = !this.open; }

  setOpen(value: boolean) {
    this.open = value;
  }
}